export enum EAuthStatus {
	Unknown = 'unknown',
	Authenticating = 'authenticating',
	Authenticated = 'authenticated',
	Unauthenticated = 'unauthenticated',
}

export type TAuthTokens = {
	accessToken: string;
	refreshToken: string | null;
	expiresAt: number;
	sessionState: string | null;
};

export type TRawTokenResponse = {
	accessToken?: string | null;
	access_token?: string | null;
	refreshToken?: string | null;
	refresh_token?: string | null;
	expiresIn?: number | null;
	expires_in?: number | null;
	expiresAt?: number | null;
	sessionState?: string | null;
	session_state?: string | null;
};

export type TTokenExchangeRequest = {
	code: string;
	sessionState: string;
	redirectUri: string;
	codeVerifier?: string;
};

export type TTokenClient = {
	exchangeAuthorizationCode: (payload: TTokenExchangeRequest) => Promise<TAuthTokens | null>;
	requestRefreshedTokens: (refreshToken: string) => Promise<TAuthTokens | null>;
	endSsoSession: (refreshToken: string, accessToken: string | null) => Promise<unknown>;
};

export type TAuthListener = (status: EAuthStatus) => void;
